import {
    getParentCategoryFromSubCategory,
    isSubCategory,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { useEffect, useRef } from 'react';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useRouteContext } from '../../context';
import { useLocationByLocationSlug } from '../queries/location';

const generateTitle = ({
    activeTag,
    loc,
}: {
    activeTag: string;
    loc: string;
}) => {
    const tag = CATEGORY_CONTENT_MAP[activeTag].title;

    if (isSubCategory(activeTag)) {
        const parentTagKey = getParentCategoryFromSubCategory(activeTag);
        const parentTag = CATEGORY_CONTENT_MAP[parentTagKey].title;
        return gettext(
            '%(category)s: %(subcategory)s Events & Tickets in %(loc)s | Eventbrite',
            {
                category: parentTag,
                subcategory: tag,
                loc: loc,
            },
        );
    }
    return gettext('%(loc)s %(tag)s Events | Eventbrite', {
        tag: tag,
        loc: loc,
    });
};

export const useUpdatePageTitle = () => {
    const value = useRouteContext();
    const firstRender = useRef(true);

    const pathname = value?.location?.pathname;
    const search = value?.location?.search;
    const match = value?.match;
    const activeTag = value?.parsedValues?.activeTag || '';

    const { data } = useLocationByLocationSlug(
        match?.params?.locationSlug || '',
    );
    const currentPlace = data?.currentPlace;
    const currentPlaceParent = data?.currentPlaceParent;

    useEffect(() => {
        if (!firstRender.current && currentPlace && activeTag) {
            const newTitle = generateTitle({
                loc: currentPlaceParent
                    ? `${currentPlace}, ${currentPlaceParent}`
                    : currentPlace,
                activeTag,
            });

            document.title = newTitle.toString();
        }
        firstRender.current = false;
    }, [pathname, search, currentPlace, currentPlaceParent, activeTag]);
};
